import React, { FunctionComponent } from 'react';

import ReactSlider from 'react-slider';

export interface SliderChangedEvent {
    ids?: string[];
    values: number[];
}

interface Props {
    value: number | number[];
    onAfterChange: (e: SliderChangedEvent) => void;
    onChange?: (e: SliderChangedEvent) => void;
    ids?: string[];
    min?: number;
    max?: number;
    pearling?: boolean;
}

const Slider: FunctionComponent<Props> = ({ ids, value, min, max, pearling, onAfterChange, onChange }) => {

    const shouldTrackBeColored = (trackIndex: number) => {
        if(Array.isArray(value)) {
            return trackIndex !== 1;
        }

        return trackIndex !== 0;
    };

    const renderThumb = (props: any) => <div {...props} />

    const renderTrack = (props: any, state: any) => (
        <div {...props} className={`slider__track ${shouldTrackBeColored(state.index) ? 'slider__track--grey' : ''}`} />
    );

    const onAfterValueChange = (value: number | number[]) => {
        const values = Array.isArray(value) ? value : [value];
        onAfterChange({ ids, values });
    };

    const onValueChange = (value: number | number[]) => {
        const values = Array.isArray(value) ? value : [value];
        onChange?.({ ids, values });
    };

    return (
        <div className={'slider__container'}>
            <ReactSlider
                value={value}
                onChange={onValueChange}
                onAfterChange={onAfterValueChange}
                className={'slider'}
                thumbClassName="slider__thumb"
                renderThumb={renderThumb}
                renderTrack={renderTrack}
                min={min}
                max={max}
                pearling={pearling} />
        </div>
    );
};

export default Slider;
